import { AlmeUIResponse} from '@alme/ui-web/types/response';
import { Store } from "redux";

import {settings} from '@alme/ui-web/settings/settings-util';
import {AlmeResponseV5} from '@alme/types/response/AlmeResponse';
import {ResponseAction} from '@alme/types/response/ResponseAction';
import ResponseActionHandler from '@alme/ui-web/types/response-action-handler';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
//@ts-ignore
import {enableInputBox, disableInputBox} from '@alme/ui-web/modules/lib-inputbox-toggle/lib/lib-inputbox-toggle';

interface InputBoxStateResponseAction extends ResponseAction{
    Disabled: string;
}

export default class InputLockResponseHandler extends ResponseActionHandler{
    
    constructor(passedSettings?: typeof settings) {
        super(["ConverseRequest", "AppeventRequest"], ["InputBoxState"], passedSettings);
    }

    initialize(store: Store<AlmeState>): void {
        this._store = store;
    }

    processResponse(response: AlmeUIResponse): AlmeUIResponse {
        const ra: InputBoxStateResponseAction = this.getFirstResponseActionNamed(response as AlmeResponseV5) as InputBoxStateResponseAction;
        if(ra.Disabled == "true") {
            disableInputBox(this._store, this._settings, () => true);
        }
        else {
            enableInputBox(this._store, this._settings, () => true);
        }

        return response;
    }

}


// WEBPACK FOOTER //
// ./modules/response-handler-input-lock/response-handler-input-lock.ts